<template>
  <Teleport to="body">
    <div v-if="visible" class="fixed inset-0 z-[10001] flex items-center justify-center bg-black/50" @click.self="choose('cancel')">
      <div class="bg-white rounded-lg shadow-xl w-[460px] max-w-[92vw] p-6" @click.stop>
        <h2 class="text-lg font-semibold mb-3">Buchungskonflikt</h2>
        <p class="text-sm text-gray-700 mb-5 leading-relaxed">
          Für den Zeitraum vom <strong>{{ info.startLabel }}</strong> bis zum <strong>{{ info.endLabel }}</strong>
          hat <strong>{{ info.userName }}</strong> bereits eine Buchung im Projekt
          <strong :style="info.projectColor ? { color: info.projectColor } : undefined">{{ info.projectName }}</strong>.
          Wie möchten Sie fortfahren?
        </p>
        <div class="flex flex-col gap-2">
          <button
            class="w-full text-left px-4 py-2 rounded border border-gray-300 hover:bg-gray-100 text-sm"
            @click="choose('overwrite')"
          >
            <span class="font-medium">Überschreiben</span><br>
            <span class="text-xs text-gray-500">Die bestehende Buchung wird im Konfliktbereich zurechtgeschnitten.</span>
          </button>
          <button
            class="w-full text-left px-4 py-2 rounded border border-gray-300 text-sm"
            :class="info.partialAvailable ? 'hover:bg-gray-100' : 'opacity-40 cursor-not-allowed'"
            :disabled="!info.partialAvailable"
            @click="info.partialAvailable && choose('partial')"
          >
            <span class="font-medium">Nur soweit möglich</span><br>
            <span class="text-xs text-gray-500">Änderung nur bis an die bestehende Buchung heran; diese bleibt unangetastet.</span>
          </button>
          <button
            class="w-full text-left px-4 py-2 rounded border border-gray-300 hover:bg-gray-100 text-sm"
            @click="choose('cancel')"
          >
            <span class="font-medium">Keine Änderung</span>
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref } from 'vue'

const visible = ref(false)
const info = ref({})
let resolver = null

// open(info) -> Promise<'overwrite' | 'partial' | 'cancel'>
function open(conflictInfo) {
  info.value = conflictInfo || {}
  visible.value = true
  return new Promise((resolve) => { resolver = resolve })
}

function choose(choice) {
  visible.value = false
  resolver?.(choice)
  resolver = null
}

defineExpose({ open })
</script>
